// src/Components/BankingReconciliation/components/ReconStatusDonut.jsx
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import Styles from "./ReconStatusDonut.module.css";
import { STATUS_META, STATUS_ORDER } from "../../utils/reconFormat";

const ReconStatusDonut = ({ statusCounts, total }) => {
  const data = STATUS_ORDER.map((key) => ({
    key,
    name: STATUS_META[key].label,
    value: statusCounts[key] || 0,
    color: STATUS_META[key].color,
  }));

  return (
    <section className={Styles.card}>
      <span className={Styles.label}>RECONCILIATION STATUS</span>
      <div className={Styles.body}>
        <div className={Styles.chartWrap}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                innerRadius={46}
                outerRadius={62}
                startAngle={90}
                endAngle={-270}
                paddingAngle={2}
                stroke="none"
              >
                {data.map((d) => (
                  <Cell key={d.key} fill={d.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className={Styles.centerLabel}>
            <div className={Styles.centerNum}>{total}</div>
            <div className={Styles.centerText}>requisitions</div>
          </div>
        </div>

        <ul className={Styles.legend}>
          {data.map((d) => (
            <li key={d.key} className={Styles.legendItem}>
              <span className={Styles.legendDot} style={{ background: d.color }} />
              <span className={Styles.legendName}>{d.name}</span>
              <span className={Styles.legendCount}>{d.value}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ReconStatusDonut;
